import FnrFetch from "Utilities/FnrFetch";

const devAPI = {
  getSignupLists123: () => {
    return FnrFetch.mock(
      {
        success: true,
        signupLists: [
          {
            ID: 1,
            title: "Sunday Mass - May 31",
            numberOfSignups: Math.floor(Math.random() * (400 - 1 + 1)) + 1,
            maxPossibleSignups: 400,
            expireDate: 1591419600,
          },
          {
            ID: 2,
            title: "Sunday Mass - June 5",
            numberOfSignups: Math.floor(Math.random() * (400 - 1 + 1)) + 1,
            maxPossibleSignups: 400,
            expireDate: 1591419600,
          },
          {
            ID: 3,
            title: "Sunday Mass - June 12",
            numberOfSignups: Math.floor(Math.random() * (400 - 1 + 1)) + 1,
            maxPossibleSignups: 400,
            expireDate: 1591419600,
          },
          {
            ID: 4,
            title: "Sunday Mass - June 19",
            numberOfSignups: Math.floor(Math.random() * (400 - 1 + 1)) + 1,
            maxPossibleSignups: 400,
            expireDate: 1591419600,
          },
          {
            ID: 5,
            title: "Sunday Mass - June 26",
            numberOfSignups: Math.floor(Math.random() * (400 - 1 + 1)) + 1,
            maxPossibleSignups: 400,
            expireDate: 1591419600,
          },
        ],
      },
      {
        // possible errors: no_signuplist, no_network, no_admin
        //error: 'no_signuplist'
      }
    );
  },

  getSignupListInfo123: () => {
    return FnrFetch.mock({
      success: true,
      signupList: {
        ID: 123,
        title: "Signup for my awesome event",
        description: "Pick a time you nerd",
        signupItems: [
          {
            ID: 1,
            title: "8:15AM",
            totalSlots: 100,
            slotsTaken: 100,
            maxSingleUserSlots: 10,
          },
          {
            ID: 2,
            title: "9:30AM",
            totalSlots: 100,
            slotsTaken: 82,
            maxSingleUserSlots: 10,
          },
          {
            ID: 3,
            title: "11:00AM",
            totalSlots: 100,
            slotsTaken: 40,
            maxSingleUserSlots: 10,
          },
          {
            ID: 4,
            title: "5:15PM",
            totalSlots: 100,
            slotsTaken: 30,
            maxSingleUserSlots: 10,
          },
        ],
      },
      user: false,
      userSignupItems: {
        //3: 2,
      },
    });
  },

  signupForItem: (itemID, numberOfSlots, noteID, user) => {
    const useMock = false;

    const mockData =
      // false && itemID % 2 === 0
      useMock
        ? {
            success: false,
            error: "no_open_slots",
          }
        : {
            success: true,
            itemSlotsTaken: [
              {
                itemID: 1,
                slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
              },
              {
                itemID: 2,
                slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
              },
              {
                itemID: 3,
                slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
              },
              {
                itemID: 4,
                slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
              },
            ],
            userSignupItems: {
              [itemID]: numberOfSlots ?? 2,
            },
          };

    if (user) mockData.signupUserID = 22;

    return FnrFetch.mock(mockData);
  },

  signupForItemFail: (itemID) => {
    return FnrFetch.mock({
      success: false,
      error: "no_open_slots",
    });
  },

  cancelSignupForItem: (itemID) => {
    return FnrFetch.mock({
      success: true,
      itemSlotsTaken: [
        {
          itemID: 1,
          slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
        },
        {
          itemID: 2,
          slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
        },
        {
          itemID: 3,
          slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
        },
        {
          itemID: 4,
          slotsTaken: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
        },
      ],
      cancelled: true,
      userSignupItems: {},
    });
  },
};

export default devAPI;
